import React, { memo } from 'react';
import { LeaderboardStore } from '../hooks/useLeaderboard';

interface LeaderboardProps {
  stores: LeaderboardStore[];
  division: string;
  isActive: boolean;
}

const Leaderboard = memo(function Leaderboard({
  stores,
  division,
  isActive,
}: LeaderboardProps) {
  if (stores.length === 0) {
    return (
      <div className="leaderboard-empty">
        <p>No stores found for Division {division}.</p>
        {!isActive && (
          <p className="competition-inactive">
            The competition is currently inactive.
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="leaderboard-container">
      {!isActive && (
        <div className="competition-notice">
          <p>⚠️ Competition is not currently active. Showing final results.</p>
        </div>
      )}

      <table className="leaderboard-table">
        <thead>
          <tr>
            <th className="rank-column">Rank</th>
            <th className="store-column">Store Name</th>
            <th className="redemptions-column">Redemptions</th>
          </tr>
        </thead>
        <tbody>
          {stores.map((store) => (
            <tr
              key={`${store.rank}-${store.store_name}`}
              className={store.rank <= 3 ? `rank-${store.rank}` : ''}
            >
              <td className="rank-column">
                <span className="rank-badge">{store.rank}</span>
              </td>
              <td className="store-column">{store.store_name}</td>
              <td className="redemptions-column">
                {store.total_redemptions.toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default Leaderboard;
